// Redux utils
import { useSelector } from "react-redux";
// React utils
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// Packages components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// Contexts
import { useCart } from "@/contexts/CartContext";

import Modal from "@/components/Modals/Modal";

export default function FixedAddToCart({
  evento,
  responsive,
  onAddToCart,
  ticketsInfo = {},
}) {
  const { openCartModal, getTotalItems } = useCart();
  const { hasTickets = false, totalTickets = 0 } = ticketsInfo;
  const navigate = useNavigate();
  const [showRutModal, setShowRutModal] = useState(false);

   // carritos from Redux
  const { carritos } = useSelector(state => state.carrito);
  const { user } = useSelector(state => state.auth);
  // console.log("Current user in FixedAddToCart:", user?.numeroTributario);
  // console.log("Rendering CartItemTicket with ticket:", ticket, "carritoUid:", carritoUid, "carritos:", carritos);
  // // contar cuantos tickets tiene el carrito actual
  // const currentCart = carritos.find(cart => cart.carritoUid === carritoUid);
  // const totalTicketsInCart = currentCart ? currentCart.tickets.reduce((sum, t) => sum + t.cantidad, 0) : 0;
  // console.log("Total tickets in current cart:", totalTicketsInCart);
  console.log("Rendering FixedAddToCart with evento:", evento);
  
  const handleButtonClick = async () => {
    const ticketsEnCarrito = getTotalItems(evento.id);
    console.log("handleButtonClick called - hasTickets:", hasTickets, "ticketsEnCarrito:", ticketsEnCarrito, "evento.id:", evento.id);
    
    // Caso 1: Usuario quiere agregar nuevos tickets seleccionados
    if (hasTickets) {
      console.log("Caso 1: Agregar nuevos tickets");
      // Validar RUT antes de agregar al carrito
      if (user?.numeroTributario === null || user?.numeroTributario === undefined || user?.numeroTributario === '') {
        setShowRutModal(true);
        return;
      }
      
      // Agregar tickets al carrito
      if (onAddToCart) {
        const success = await onAddToCart();
        if (success) {
          openCartModal(evento.id);
        }
      }
      return;
    }
    
    // Caso 2: Ya hay tickets en el carrito, solo quiere verlo
    if (ticketsEnCarrito > 0) {
      console.log("Caso 2: Ver carrito - Llamando openCartModal con evento.id:", evento.id);
      openCartModal(evento.id);
      console.log("openCartModal llamado");
      return;
    }
    
    // Caso 3: No hay tickets seleccionados ni en el carrito, scroll a la sección
    console.log("Caso 3: Scroll a tickets section");
    const ticketsSection = document.querySelector("[data-tickets-section]");
    if (ticketsSection) {
      ticketsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const getButtonText = () => {
    const ticketsEnCarrito = getTotalItems(evento.id);
    const ticketsRestantes = totalTickets - ticketsEnCarrito;
    console.log("Rendering FixedAddToCart with ticketsInfo:", {ticketsInfo, ticketsEnCarrito, ticketsRestantes});
    if (hasTickets) {
      switch (ticketsRestantes) {
        case 0:
          return `Ver Carrito (${getTotalItems(evento.id)})`;
        case 1:
          return `Agregar 1 Ticket`;
        default:
          return `Agregar ${ticketsRestantes} Ticket${
            ticketsRestantes !== 1 ? "s" : ""
          }`;
      }
    } else if (getTotalItems(evento.id) > 0) {
      return `Ver Carrito (${getTotalItems(evento.id)})`;
    } else {
      return "Selecciona Tickets";
    }
  };

  const getButtonIcon = () => {
    if (getTotalItems(evento.id) > 0) {
      return "fa-solid fa-shopping-cart";
    } else {
      return "fa-solid fa-cart-shopping";
    }
  };
  return (
    <>
      <div className={`${responsive} sticky w-full z-[80]`}>
        <div className="w-full bg-aw-bluedark border-t border-aw-green p-2 sm:p-4 flex items-center justify-center">
          <div className="w-full lg:w-1/2 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img
                src={evento.img}
                alt={evento.titulo}
                className="hidden sm:block sm:w-12 sm:h-12 rounded-lg object-cover"
              />
              <div className="flex flex-col text-white">
                <h4 className="text-sm font-semibold line-clamp-1">
                  {evento.titulo}
                </h4>
                <span className="text-xs">
                  <FontAwesomeIcon
                    icon={"fa-solid fa-map-marker-alt"}
                    className="text-red-500 mr-1"
                  />
                  {evento.direccion ||
                    evento.ubicacion ||
                    "Ubicación por confirmar"}
                </span>
              </div>
            </div>
            {/* Button with dynamic functionality */}
            <button
              onClick={handleButtonClick}
              className={`px-4 py-2 rounded-full font-bold border transition text-center text-xs sm:text-sm ${
                hasTickets
                  ? "bg-aw-green text-aw-bluedark hover:bg-aw-bluedark hover:text-aw-green border-aw-green"
                  : getTotalItems(evento.id) > 0
                  ? "bg-aw-green text-aw-bluedark hover:bg-aw-bluedark hover:text-aw-green border-aw-green"
                  : "bg-transparent text-aw-green hover:bg-aw-green hover:text-aw-bluedark border-aw-green"
              }`}
            >
              {getButtonText()}{" "}
              <FontAwesomeIcon icon={getButtonIcon()} className="ml-2" />
              {getTotalItems(evento.id) > 0 && (
                <span className="ml-1 bg-aw-bluedark text-aw-green text-xs px-1.5 py-0.5 rounded-full">
                  {getTotalItems(evento.id)}
                </span>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Modal para requerir RUT */}
      <Modal
        isOpen={showRutModal}
        onClose={() => setShowRutModal(false)}
        title="RUT Requerido"
        large="max-w-xl"
      >
        <div className="p-6 text-center bg-aw-bluedark rounded-lg space-y-4 inset-shadow-sm inset-shadow-aw-green shadow-sm shadow-aw-green">
          <FontAwesomeIcon
            icon="fa-solid fa-id-card"
            size="4x"
            className="text-aw-green mx-auto"
          />
          <h2 className="text-2xl font-bold text-white">RUT Requerido</h2>
          <p className="text-gray-300">
            Por favor, actualiza la información de tu perfil, agregando tu RUT antes de agregar tickets al carrito.
          </p>
          <div className="flex gap-3 justify-end">
            <button
              onClick={() => setShowRutModal(false)}
              className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition"
            >
              Cancelar
            </button>
            <button
              onClick={() => {
                setShowRutModal(false);
                navigate(`/perfil/${user?.uid}`);
              }}
              className="px-4 py-2 bg-aw-green text-aw-bluedark rounded-lg font-semibold hover:bg-aw-green/90 transition"
            >
              Ir a Mi Perfil
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
